/*
 * Copyright (c) Vaisala Oyj. All rights reserved.
 */

import { useTranslation } from 'react-i18next';
import { BodyText, Button, ButtonType, Icon, Size } from '@vaisala-rockhopper/components';
import { ModalInstance, ModalProps } from './Modals';
import { VaiIcon } from '@vaisala-rockhopper/design-tokens';
import './Modals.scss';

const InstallPWAModal = (props: ModalProps) => {
  const { onAccept, onReject } = props;
  const { t } = useTranslation('a-parameter-calculator');
  return (
    <ModalInstance modalId="modal.pwa" {...props} title={t('ui.pwa.title')}>
      <BodyText>{t('ui.pwa.body')}</BodyText>
      <div className="illustration" />
      <div className="buttons-wrap">
        <Button buttonType={ButtonType.Primary} buttonSize={Size.M} startIcon={<Icon name={VaiIcon.Download} />} onClick={onAccept}>
          {t('ui.pwa.buttonYes')}
        </Button>
        <Button buttonType={ButtonType.Secondary} buttonSize={Size.M} onClick={onReject}>
          {t('ui.pwa.buttonNo')}
        </Button>
      </div>
    </ModalInstance>
  );
};

export default InstallPWAModal;
